import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Product, FirebaseParameter, ListOfProducts } from 'src/app/models/product';
import { Router } from '@angular/router';
import { ProductService } from 'src/app/services/product.service';
import * as firebase from 'firebase';
import { formatDate } from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-product-success-add',
  templateUrl: './product-success-add.component.html',
  styleUrls: ['./product-success-add.component.css']
})
export class ProductSuccessAddComponent implements OnInit {
  public product: Product = new Product();
  public message = '';
  public isSuccess = false;
  public modalProductSuccessAdded = 'modal-product-success-added';
  isLoadingStock: boolean = false;
  stock: number = 0;

  listOfProduct: FirebaseParameter[] = ListOfProducts;

  expireDate = '';
  isLoadingExpireDate = false;

  constructor(private productService: ProductService, private router: Router) { }

  ngOnInit() {
  }
  loadStock(){
    this.isLoadingStock = true;
    this.productService.getProductStock(this.product.code, this.product.unit_of_measure,
      resp => {
        this.isLoadingStock = false;
        if(resp.alert.code == 200){
          this.stock = resp.data;
        }else{
          console.log(resp);
        }
      },
      err => {
        this.isLoadingStock = false;
        console.log(err);
      });
  }

  public showWithData(product: Product,
    isSuccess: boolean,
    message = ''): void {
      this.product = product;
      this.isSuccess = isSuccess;
      this.message = message;

      const target = this.listOfProduct.find(x => x.code === this.product.code.toLowerCase());
        if (target) {
          firebase.analytics().logEvent(target.event, {
            add_to_cart: target.value
          });
        }

      this.show();
      this.loadStock();
      this.getExpireDateProduct();
  }

  public show(): void {
    this.loadStock();
    $('#' + this.modalProductSuccessAdded).modal('show');
  }

  public hide(): void {
    $('#' + this.modalProductSuccessAdded).modal('hide');
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }

  public goToCart(): void {
    this.router.navigate(['/cart']);
  }

  // CR-15
  getExpireDateProduct(): void {
    let productCode = [];
    productCode.push(this.product.code);

    const param = {
      productCode: productCode
    };

    this.isLoadingExpireDate = true;
    this.productService.getExpireDateProduct(param,
      (data) => {
        if (data[0].bathcEd === '0') {
          this.expireDate = '-';
        } else {
          this.expireDate = formatDate(data[0].bathcEd, 'dd MMMM yyyy', 'id');
        }

        this.isLoadingExpireDate = false;
      },
      (err) => {
        this.isLoadingExpireDate = false;
        console.log(err);
      }
    );
  }
}
